import React, 
       { useState, 
         useEffect, 
         useRef, 
         useLayoutEffect}                   from "react";
import { useLoader}                         from "components/Covers/loadingCover";
import { useActionModal}                    from "components/Covers/confirmAction";
import { useInfoMsgModal}                   from "components/Covers/infoMessageModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { useBtnExit }                       from "components/Covers/exitAction";
import { InputGeneral}                      from "components/Field/field";
import  MainStyle                           from "components/UI/main.module.scss";
import { getOrderPreviewByCode }            from "./orderCodeService";
import { useNavigate, useParams    }        from "react-router-dom";
import { Select, Rate }                     from "antd";


import { q3x_FunData, 
         getImgSrc, 
         DefaultLoadingISELogo,
         GetLabel 
        }                                   from "Utilities/utils";
import BtnChangeTheme                       from "components/Buttons/Theme/BtnTheme";

// #region Object Template
const blank_answer_template = {
    SESSION_ORDER:       0,
    QUESTION_ID:         0,
    QUESTION_TYPE_ID:    0,
    QUESTION_POSITION:   0,
    ANSWER_VALUE:        "",
    OBSERVATION:         "",
};
const blank_answer_option_template = {
    SESSION_ORDER:       0,
    QUESTION_ID:         0, 
    QUESTION_TYPE_ID:    0,
    QUESTION_POSITION:   0,
    OPTION_LIST_ID:      0,
    OPTION_LIST_ITEM_ID: 0,
    OBSERVATION:         ""
};
// #endregion

// #region Layout Helppers
const SearchableDropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
      />
    );
};
const DropdownList = ({
    className,
    style,
    onChange,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value}) => {
  return (
    <Select
      name={name}
      id={id}
      placeholder={placeholder}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      options={listOfItems}
      className={className}
      style={style}
      onChange={onChange}
      defaultValue={defaultValue}
      title={title}
      popupClassName={popupClassName}
      value={value}
    />
  );
};
const DefaultPadding = () =>{
    return(<div className={MainStyle.py_3}/>);
};
const DivisionBlock = () => {
    return(
        <>
            <div className={[MainStyle.py_2].join(" ")}>
                <div className={MainStyle.row}>
                    <div className={[MainStyle.col_lg, MainStyle.border_bottom].join(" ")}/>
                </div>
            </div>
        </>
    );
};
const OrderTemplateColor = (obj) => {
    if (obj != null && obj.COLOR != 0 && obj.COLOR_DATA != "") {
        return (obj.COLOR_DATA);
    }
    else {
        return null;
    }
};
// #endregion

// #region Layout Header
const MinHeader = React.memo(({...other}) => {
    const { data,
            lang,
            fontSize,
            controlHeight,
            contentHeight,                  } = other;
    const [ isVisible,     setIsVisible    ] = useState(false);
    const [ mainPosition,  setMainPosition ] = useState(-200);
    const [ scrollHeight,  setScrollHeight ] = useState(0);
    const [ expanded,      setExpanded     ] = useState(false);
    const [ innerHeight,   setInnerHeight  ] = useState(0);
    const [ overFlow,      setOverFlow     ] = useState("hidden");
    const intervalRef                        = useRef(null);     
    const mainIntervalRef                    = useRef(null);
    const mainDivRef                         = useRef(null);

    const handleClick = () => {
        if (intervalRef.current) return;

        if (!expanded) {
            setExpanded(true);
            intervalRef.current = setInterval(() => {
            setInnerHeight(prev => {
                if (prev >= 100) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                return 100;
                }
                return prev + 1;
            });
            setOverFlow("scroll");
            }, 5);
        } else {
            intervalRef.current = setInterval(() => {
            setInnerHeight(prev => {
                if (prev <= 0) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
                setExpanded(false); // Close only after animation ends
                return 0;
                }
                return prev - 1;
            });
            setOverFlow("hidden");
            }, 5);
        }
    };

    useEffect(() => {
        function updateProgress() {
            let current = window.scrollY;
            if (current >= contentHeight.top) {
            
                let scrollableContent = parseInt((contentHeight.height - contentHeight.top));
                let scrolledContent  = parseInt((current - contentHeight.top));
                let scrolled = (scrolledContent / scrollableContent) * 100;
                scrolled = Math.min(Math.max(scrolled, 0), 100);
                setScrollHeight(`${scrolled}%`);
            }
        }
    
        function handleScroll() {
            updateProgress();
        
            const currentPosition = window.scrollY;
            const shouldBeVisible = currentPosition > controlHeight?.bottom;
        
            // Only update state if needed
            setIsVisible(prev => {
                if (prev !== shouldBeVisible) {
                    return shouldBeVisible;
                }
                return prev;
            });
        }
    
        if (controlHeight) {
            window.addEventListener("scroll", handleScroll, updateProgress);
        }
    
        // Animation logic
        if (!mainIntervalRef.current) {
            const target = isVisible ? 0 : -200;
        
            // Only animate if the current position is different
            if ((isVisible && mainPosition < 0) || (!isVisible && mainPosition > -200)) {
                mainIntervalRef.current = setInterval(() => {
                    setMainPosition(prev => {
                        const done = isVisible ? prev >= target : prev <= target;
                        if (done) {
                            clearInterval(mainIntervalRef.current);
                            mainIntervalRef.current = null;
                            return target;
                        }
                        return isVisible ? prev + 5 : prev - 5;
                    });
                }, 1);
            }
        }
    
        return () => {
            // Cleanup
            clearInterval(mainIntervalRef.current);
            mainIntervalRef.current = null;
        
            if (controlHeight) {
                window.removeEventListener("scroll", handleScroll, updateProgress);
            }
        };
    }, [controlHeight, isVisible, contentHeight, mainPosition]);

    return (
        <>
            <div ref={mainDivRef} style={{top: mainPosition, transition: '0.3s ease-in-out', position: 'fixed'}} className={MainStyle.nav_bar_answer_position}>
                <div className={[MainStyle.bg_card_header_answer, MainStyle.shadow, MainStyle.border_bottom].join(" ")}>
                        <div className={[MainStyle.d_flex, MainStyle.justify_content_around, MainStyle.py_2].join(" ")}>
                            {((data?.LOGO1 != 0) && (data?.LOGO1 != null) && (data?.LOGO1_DATA != "") && (data?.LOGO1_DATA != null)) && (
                                <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                                        className={MainStyle.nav_bar_answer_logo}
                                        src={getImgSrc(data?.LOGO1_DATA)}
                                />
                            )}
                            {((data?.LOGO2 != 0) && (data?.LOGO2 != null) && (data?.LOGO2_DATA != "") && (data?.LOGO2_DATA != null)) && (
                                <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                                        className={MainStyle.nav_bar_answer_logo}
                                        src={getImgSrc(data?.LOGO2_DATA)}
                                />
                            )}
                            {((data?.LOGO3 != 0) && (data?.LOGO3 != null) && (data?.LOGO3_DATA != "") && (data?.LOGO3_DATA != null)) && (
                                <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                                        className={MainStyle.nav_bar_answer_logo}
                                        src={getImgSrc(data?.LOGO3_DATA)}
                                />
                            )}
                        </div>
                        <div style={{backgroundColor: OrderTemplateColor(data), width: scrollHeight}} className={[MainStyle.d_flex, MainStyle.pb_1].join(" ")}/>
                </div>
                {data.SUBTI_LANG === "Y" && (
                    expanded ?
                        <>
                            <div 
                                className={[MainStyle.bg_card_inner, MainStyle.shadow, MainStyle.border_bottom].join(" ")}
                                style={{
                                    height: `${Math.floor(innerHeight / 10.0)}rem`,
                                    overflowY: `${overFlow}`,
                                    transition: 'height 0.1s linear',
                                    }}
                            >
                                <div className={MainStyle.mx_3}>
                                    {data.SUBTI_LANG === "Y" && (
                                        <React.Fragment>
                                            <p className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body, MainStyle.fw_semibold].join(" ")}>
                                                {GetLabel(lang, 408)}
                                            </p>
                                            <span className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body, MainStyle.text_pre_wrap].join(" ")}>
                                                {data.SUBTI_LANG === "Y" && ( data[`SUBTI_LANG_${lang}_DESC`].replaceAll('|n|', '\n'))}
                                            </span>
                                        </React.Fragment>                                                   
                                    )}
                                </div>                                                                            
                            </div>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")} style={{zIndex: '99'}}>
                                <div className={[MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card_item, MainStyle.rounded_bottom].join(" ")} onClick={() => {handleClick();}} style={{cursor: "pointer"}}>
                                        <div className={[MainStyle.m_2].join(" ")}>
                                            <svg    viewBox="0 0 512 512"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className={[MainStyle.header_answer_button_ico, MainStyle.mt_1].join(" ")}
                                            >
                                                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/>
                                            </svg>
                                        </div>
                                </div>
                            </div>                      
                        </>
                        :
                        <>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_end].join(" ")} style={{zIndex: '99'}}>
                                    <div 
                                        style={{
                                            height: `${Math.floor(innerHeight / 5.0)}rem`,
                                            overflowY: `${overFlow}`,
                                            transition: 'height 0.1s linear',
                                        }}
                                    >
                                    </div>
                                    <div className={[MainStyle.shadow_sm, MainStyle.border, MainStyle.bg_card_item, MainStyle.rounded_bottom].join(" ")} onClick={() => {handleClick();}} style={{cursor: "pointer"}}>
                                            <div className={[MainStyle.m_2].join(" ")}>
                                                <svg    viewBox="0 0 320 512" 
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={[MainStyle.header_answer_button_ico, MainStyle.mt_1].join(" ")}
                                                >
                                                    <path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/>
                                                </svg>
                                            </div>
                                    </div>
                            </div>
                        </>
                )}
            </div>
        </>
    );
});

const InfoBlock = React.memo(({...other}) => {
    const { data,
            lang,
            setLang,                
            langList,
            fontSize,
            setFontSize,                      } = other;

    const ThemeSelector = () => {
        return (
            <>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_4}/>
                    <div className={MainStyle.col_4}>
                        <div className={MainStyle.mx_3}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <div className={MainStyle.mx_1}>
                                    <BtnChangeTheme/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={MainStyle.col_4}/>
                </div>
            </>
        );
    };

    const LanguageSelector = () => {
        return (            
            langList.length > 1 ? 
                <React.Fragment>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_3}/>
                        <div className={MainStyle.col_6}>
                            <div className={MainStyle.mx_3}>
                                <DropdownList
                                    value={langList?.find((i) => i.value === lang)}
                                    listOfItems={langList}
                                    style={{ width: "100%" }}
                                    className={[MainStyle.mt_2, MainStyle.text_center].join(" ")}
                                    onChange={(event) => {setLang(event);}}
                                />
                            </div>
                        </div>
                        <div className={MainStyle.col_3}/>
                    </div>
                </React.Fragment>
            :
                null
        );
    };

    const FontSizeSelector = () => {
        let fontList =[
            {value: 5, label: GetLabel(lang, 503)},
            {value: 6, label: GetLabel(lang, 505)},
            {value: 7, label: GetLabel(lang, 504)},
        ];
        return (
            <>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_3}/>
                    <div className={MainStyle.col_6}>
                        <div className={MainStyle.mx_3}>
                            <DropdownList
                                value={fontList?.find((i) => i.value === fontSize)}
                                listOfItems={fontList}
                                style={{ width: "100%" }}
                                className={[MainStyle.mt_2, MainStyle.text_center].join(" ")}
                                onChange={(event) => {setFontSize(event);}}
                            />
                        </div>
                    </div>
                    <div className={MainStyle.col_3}/>
                </div>
            </>
        );
    };

    const MainHeader = () => {
        return(
            <>
                <DefaultPadding/>
                {((data?.LOGO1 != 0) && (data?.LOGO1 != null) && (data?.LOGO1_DATA != "") && (data?.LOGO1_DATA != null)) && (
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_3].join(" ")}>
                        <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                             className={MainStyle.answer_logo}
                             src={getImgSrc(data?.LOGO1_DATA)}
                        />
                    </div>
                )}
                {((data?.LOGO2 != 0) && (data?.LOGO2 != null) && (data?.LOGO2_DATA != "") && (data?.LOGO2_DATA != null)) && (
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_3].join(" ")}>
                        <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                             className={MainStyle.answer_logo}
                             src={getImgSrc(data?.LOGO2_DATA)}
                        />
                    </div>
                )}
                {((data?.LOGO3 != 0) && (data?.LOGO3 != null) && (data?.LOGO3_DATA != "") && (data?.LOGO3_DATA != null)) && (
                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center, MainStyle.my_3].join(" ")}>
                        <img style={{  objectFit: 'scale-down', objectPosition: '50% 50%'}} 
                             className={MainStyle.answer_logo}
                             src={getImgSrc(data?.LOGO3_DATA)}
                        />
                    </div>
                )}
                <LanguageSelector/>
                {
                    //<FontSizeSelector/>
                    //<DefaultPadding/>
                    //<ThemeSelector/>
                }
                <DefaultPadding/>
            </>
        );
    };

    return (
        <>
            {
                data !== null ?
                            <MainHeader/>
                :   
                    null
            }
        </>
    );

});

const HeaderBlock = React.memo(({...other}) => {
    const { data,
            lang,
            fontSize                       } = other;

    function formatedText() {
        if (data && data.EXPLAN_LANG === "Y") {
            let textSet = data[`EXPLAN_LANG_${lang}_DESC`].split("|n|"), i = 0, renderedElements = [];
            while (i < textSet.length) {
                renderedElements.push(
                    <>
                        <span className={[MainStyle[`fs_${fontSize + 1}`], MainStyle.answer_text_body, MainStyle.header_answer_explanation_text].join(" ")}>
                            {textSet[i]}
                        </span>
                    </>
                );
                i++;
            }
            return (renderedElements);
        }
    }

    return (
        <>
            {data !== null && (
                <>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_3}/>
                        <div className={MainStyle.col_lg}>
                            <div className={[MainStyle.mx_3, MainStyle.text_center].join(" ")}>
                                <span className={[MainStyle[`fs_${fontSize - 3}`], 
                                                  MainStyle.answer_text_body, 
                                                  MainStyle.fw_semibold].join(" ")}>
                                    {data[`HEADER_LANG_${lang}_DESC_1`]}
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_3}/>
                    </div>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_3}/>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.mx_3}>
                                <p className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body, MainStyle.fw_semibold, MainStyle.text_center].join(" ")}>
                                    {data[`HEADER_LANG_${lang}_DESC_2`]}
                                </p>
                                <p className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body, MainStyle.fw_semibold, MainStyle.text_center].join(" ")}>
                                    {data[`HEADER_LANG_${lang}_DESC_3`]}
                                </p>
                                <p className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body, MainStyle.fw_semibold, MainStyle.text_center].join(" ")}>
                                    {data[`HEADER_LANG_${lang}_DESC_4`]}
                                </p>
                                <div className={[MainStyle.text_center].join(" ")}>
                                    {formatedText()}
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_3}/>
                    </div>
                </>

            )}
        </>
    );

});
// #endregion

// #region Session Line
const TeacherLine = React.memo(({data, lang, fontSize}) => {
    return (
        <>
            <div className={MainStyle.mx_2}>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body, MainStyle.fw_semibold].join(" ")}>
                        {data[`DESIGNATION_${lang}_DESC`]}:
                    </span>
                </div>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body].join(" ")}>
                        { data.FULL_NAME }
                    </span>
                </div>
            </div>
        </>
    );
});

const TeacherLineAvatar = React.memo(({data, lang, fontSize}) => {
    return (
        <>
            {((data.FILE_DATA !== "") && (data.FILE_DATA !== null)) && (
                <div className={[MainStyle.d_flex, MainStyle.justify_content_end, MainStyle.my_3].join(" ")}>
                    <div style={{overflowX: 'hidden', overflowY: 'hidden'}}
                            className={[MainStyle.border,
                                        MainStyle.shadow_sm, 
                                        MainStyle.rounded_circle, 
                                        MainStyle.teacher_avatar].join(" ")} 
                    >
                        <img src={getImgSrc(data.FILE_DATA)} style={{width: '100%',  height: '100%', objectFit:'cover', objectPosition: '50% 50%'}}/>    
                    </div>
                </div>
            )}
        </>
    );
});

const LabelLine = React.memo(({data, lang, fontSize}) => {
    return (
        <>
            <div className={MainStyle.mx_2}>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body, MainStyle.fw_semibold].join(" ")}>
                        {data[`LBL_LANG_${lang}_DESC`] !== "" ?
                            data[`LBL_LANG_${lang}_DESC`] + ':'
                            : 
                            null
                        }
                    </span>
                </div>
                <div>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body].join(" ")}>
                        {data[`TXT_LANG_${lang}_DESC`]}
                    </span>
                </div>
            </div>
        </>
    );
});

const SessionLine = React.memo(({...other}) => {
    const { data,
            index,      
            lang,
            fontSize                 } = other;
    return (
        <>
            {
                data?.TYPE_ID === 5 ?
                    <div className={MainStyle.my_3}>
                        <TeacherLine data={data} lang={lang} fontSize={fontSize}/>
                    </div>
                :            
                data?.TYPE_ID === 6 ? 
                    <LabelLine data={data} lang={lang} fontSize={fontSize}/>
                :
                null
            }
        </>
    );

});
// #endregion

// #region Display Comment
const AnswerObservation = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            lang,
            fontSize }    = other;
    

    return (
        <div className={[MainStyle.row]}>
            <div className={MainStyle.col}>
                <InputGeneral 
                    value={data.OBSERVATION || ''}
                    className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                    onChange={(event) => { 
                        setMainData((prevState) => ({
                            ...prevState,
                            SESSIONS: prevState.SESSIONS.map((session, i) =>
                                i === sessionIndex
                                ? {
                                    ...session,
                                    SESSION_QUESTIONS: session.SESSION_QUESTIONS.map((question, j) =>
                                        j === questionIndex
                                        ? {
                                            ...question,
                                            OBSERVATION: q3x_FunData(event.target.value),
                                            }
                                        : question
                                    )
                                    }
                                : session
                            )
                        }));
                    }}
                    placeholder={""}
                    style={{minHeight: 'calc(5.375rem + 1.5vw)'}}
                    maxLength={3000}
                    autoSize={true}
                />                
            </div>
        </div>
    );

});

const CommentDisplay = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            lang,
            fontSize,
            canComment,
            setCanComment, 
            displayComment,
            setDisplayComment}    = other;
    return (
        <>
            {canComment && (
                <div className={[MainStyle.my_3, MainStyle.mx_3].join(" ")}>
                    <div className={[MainStyle.row]}>
                        <div className={MainStyle.col_sm_10}>
                            <div className={MainStyle.text_start}>
                                <span className={[ MainStyle[`fs_${fontSize + 1}`], MainStyle.answer_text_body].join(" ")}>
                                    {GetLabel(lang, 506)}
                                </span>
                            </div>
                        </div>
                        <div className={MainStyle.col_sm_2}>
                            <input
                                type="checkbox"
                                name={"read"}
                                checked={displayComment}
                                onChange={()=> { displayComment === false ? setDisplayComment(true) : setDisplayComment(false);}}
                                style={{ transform: "scale(1.5)" }}
                                disabled={false}
                            />
                        </div>
                    </div>
                    {displayComment && (
                        <AnswerObservation
                            data={data}
                            mainData={mainData}
                            setMainData={setMainData}
                            sessionIndex={sessionIndex}
                            questionIndex={questionIndex}
                            lang={lang}
                            fontSize={fontSize}
                        />
                    )}
                </div>
            )}
        </>

    );
});
// #endregion

// #region Question Type 1
const QuestionType1Option = React.memo(({...other}) => {
    const { data,
            setMainData,
            sessionIndex,
            questionIndex,
            fontSize } = other;

    const handleSelect = (iData) => {
        let obj = {};
        for (let i = 0; i < data.OPTIONS.length; i++) {
            if (data.OPTIONS[i].OPTION_LIST_ITEM_ORDER === iData) {
                obj = { 
                    SESSION_ORDER:          data.OPTIONS[i].SESSION_ORDER,
                    OPTION_LIST_ID:         data.OPTIONS[i].OPTION_LIST_ID,
                    OPTION_LIST_ITEM_ID:    data.OPTIONS[i].OPTION_LIST_ITEM_ID,
                    OPTION_LIST_ITEM_ORDER: data.OPTIONS[i].OPTION_LIST_ITEM_ORDER,
                    QUESTION_ID:            data.OPTIONS[i].QUESTION_ID,
                    QUESTION_POSITION:      data.OPTIONS[i].QUESTION_POSITION,
                    QUESTION_TYPE_ID:       data.OPTIONS[i].QUESTION_TYPE_ID,
                };
                break;
            }
        }
        setMainData((prevState) => ({
            ...prevState,
            SESSIONS: prevState.SESSIONS.map((session, i) =>
              i === sessionIndex
                ? {
                    ...session,
                    SESSION_QUESTIONS: session.SESSION_QUESTIONS.map((question, j) =>
                      j === questionIndex
                        ? {
                            ...question,
                            ANSWERS: question.ANSWERS.map((answer, k) => 
                                k === 0
                                    ? {
                                        ...answer,
                                        obj

                                    }
                                    : answer
                            )
                          }
                        : question
                    )
                  }
                : session
            )
        }));
        setMainData((prevState) => {
            const sessions = [...prevState.SESSIONS];
            const newAnswer = {...obj};

            sessions[sessionIndex].SESSION_QUESTIONS[questionIndex].ANSWERS = [newAnswer];

            return {
                ...prevState,
                SESSIONS: sessions
            };
        });
    };
    return (
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg}>
                    <Rate onChange={(event) => {handleSelect(event);}}
                          className={["theme-rate", 
                                      MainStyle[`fs_star_${fontSize}`],                               
                                      MainStyle.d_flex, 
                                      MainStyle.justify_content_center, MainStyle.me_5].join(" ")}/>
                </div>
                <div className={MainStyle.col_lg_1}/>
            </div>
        </>
    );
});

const QuestionType1 = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            lang,
            fontSize }    = other;
    const [ canComment,     setCanComment     ] = useState(false);
    const [ displayComment, setDisplayComment ] = useState(false);
    
    const questionStyle = [ MainStyle[`fs_${fontSize}`], 
                MainStyle.answer_text_body, 
                data.BOLD === "Y" ? MainStyle.fw_semibold: null];

    useEffect(() => {
        if (mainData.OBSERVATIONS === "Y") {
            setCanComment(true);
        }
    }, [mainData]);

    return(
        <div className={MainStyle.my_5}>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        {data.PREFIX != "" && (
                            <span className={questionStyle.join(" ")}>
                                {data.PREFIX + " "}
                            </span>                            
                        )}
                        <span className={questionStyle.join(" ")}>
                            {data[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                        {data.MANDATORY === "Y" && (
                            <span className={questionStyle.join(" ")}>
                                *
                            </span>                            
                        )}

                    </div>
                </div>
            </div>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                    {data?.OPTIONS.length > 0 && (
                        <QuestionType1Option 
                            data={data}
                            setMainData={setMainData}
                            sessionIndex={sessionIndex}
                            questionIndex={questionIndex}
                            fontSize={fontSize}
                        />
                    )}
                    </div>
                </div>
            </div>
            {data.ANSWERS.length > 0 && (
                <CommentDisplay
                    data={data}
                    mainData={mainData}
                    setMainData={setMainData}
                    sessionIndex={sessionIndex}
                    questionIndex={questionIndex}
                    lang={lang}
                    fontSize={fontSize}
                    canComment={canComment}
                    setCanComment={setCanComment}
                    displayComment={displayComment}
                    setDisplayComment={setDisplayComment}
                />
            )}
        </div>
    );
});
// #endregion

// #region Question Type 2
const QuestionType2 = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            lang,
            fontSize }    = other;
    const [ canComment,     setCanComment     ] = useState(false);
    const [ displayComment, setDisplayComment ] = useState(false);
    
    const questionStyle = [ MainStyle[`fs_${fontSize}`], 
                MainStyle.answer_text_body, 
                data.BOLD === "Y" ? MainStyle.fw_semibold: null];
    
    useEffect(() => {
        if (mainData.OBSERVATIONS === "Y") {
            setCanComment(true);
        }
    }, [mainData]);

    return(
        <div className={MainStyle.my_5}>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        {data.PREFIX != "" && (
                            <span className={questionStyle.join(" ")}>
                                {data.PREFIX + " "}
                            </span>                            
                        )}
                        <span className={questionStyle.join(" ")}>
                            {data[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                        {data.MANDATORY === "Y" && (
                            <span className={questionStyle.join(" ")}>
                                *
                            </span>                            
                        )}

                    </div>
                </div>
            </div>
            <div className={[MainStyle.row]}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        <InputGeneral 
                            value={data.ANSWERS[0].ANSWER_VALUE || ''}
                            className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1, MainStyle.mt_2].join(" ")} 
                            onChange={(event) => { 
                                setMainData((prevState) => ({
                                    ...prevState,
                                    SESSIONS: prevState.SESSIONS.map((session, i) =>
                                        i === sessionIndex
                                        ? {
                                            ...session,
                                            SESSION_QUESTIONS: session.SESSION_QUESTIONS.map((question, j) =>
                                                j === questionIndex
                                                ? {
                                                    ...question,
                                                    ANSWERS: question.ANSWERS.map((answer, k) =>
                                                        k === 0
                                                        ? {
                                                        ...answer,
                                                        ANSWER_VALUE: q3x_FunData(event.target.value),
                                                        }
                                                        : answer
                                                    )
                                                    }
                                                : question
                                            )
                                            }
                                        : session
                                    )
                                }));
                            }}
                            placeholder={""}
                            style={{minHeight: 'calc(5.375rem + 1.5vw)'}}
                            maxLength={3000}
                            autoSize={true}
                        />
                    </div>
                </div>
            </div>
            {data.ANSWERS.length > 0 && (
                <CommentDisplay
                    data={data}
                    mainData={mainData}
                    setMainData={setMainData}
                    sessionIndex={sessionIndex}
                    questionIndex={questionIndex}
                    lang={lang}
                    fontSize={fontSize}
                    canComment={canComment}
                    setCanComment={setCanComment}
                    displayComment={displayComment}
                    setDisplayComment={setDisplayComment}
                />
            )}      
        </div>
    );
});
// #endregion

// #region Question Type 3
const QuestionType3Option = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            optionIndex,
            lang,
            fontSize        }  = other;
    const radioGroupName = `question_${sessionIndex}_${questionIndex}_${optionIndex}`;
    const handleSelect = () => {
        setMainData((prevState) => {
            const sessions = [...prevState.SESSIONS];
            const session = sessions[sessionIndex];
            const question = session.SESSION_QUESTIONS[questionIndex];
            const existingAnswer = question.ANSWERS?.[0];

            const isSameAnswer =
                existingAnswer &&
                existingAnswer.QUESTION_ID === data.QUESTION_ID &&
                existingAnswer.QUESTION_POSITION === data.QUESTION_POSITION &&
                existingAnswer.OPTION_LIST_ID === data.OPTION_LIST_ID &&
                existingAnswer.OPTION_LIST_ITEM_ID === data.OPTION_LIST_ITEM_ID;
            
            if (isSameAnswer) {
                sessions[sessionIndex].SESSION_QUESTIONS[questionIndex].ANSWERS = [];
            } else {
                const newAnswer = {
                    SESSION_ORDER: session.SESSION_ORDER,
                    QUESTION_ID: question.QUESTION_ID,
                    QUESTION_TYPE_ID: question.QUESTION_TYPE_ID,
                    QUESTION_POSITION: question.QUESTION_POSITION,
                    OPTION_LIST_ID: data.OPTION_LIST_ID,
                    OPTION_LIST_ITEM_ID: data.OPTION_LIST_ITEM_ID,
                    OPTION_LIST_ITEM_ORDER: data.OPTION_LIST_ITEM_ORDER,
                };

                sessions[sessionIndex].SESSION_QUESTIONS[questionIndex].ANSWERS = [newAnswer];
            }

            return {
                ...prevState,
                SESSIONS: sessions
            };
        });
    };
    function IsChecked() {
        return mainData.SESSIONS[sessionIndex].SESSION_QUESTIONS[questionIndex].ANSWERS.some(
            (answer) => {
                if (answer.OPTION_LIST_ITEM_ID === data.OPTION_LIST_ITEM_ID)
                {
                    return true;
                }
                else {
                    return false;
                }
            }
        );
    }
    useEffect(() => {}, [lang, fontSize]);
    return (
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_2}>
                    <input
                      type="checkbox"
                      name={radioGroupName}
                      checked={IsChecked()}
                      onChange={() => handleSelect()}
                      disabled={false}
                      className={MainStyle.mx_3}
                      style={{
                            width: '1.1rem',
                            height: '1.1rem',
                            appearance: 'none',
                            WebkitAppearance: 'none',
                            borderRadius: '50%',
                            border: '1px solid #767676',
                            cursor: 'pointer',
                            outline: 'none',
                            position: 'relative',
                            backgroundColor: IsChecked() ? '#0075ff' : 'transparent',
                            transition: 'background-color 0.5s, border-color 0.1s'
                      }}
                    />
                </div>
                <div className={MainStyle.col_10}>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body].join(" ")}>
                        {data[`OPTION_LANG_${lang}_DESC`]}
                    </span>
                </div>
            </div>
        </>
    );
});

const QuestionType3 = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            lang,
            fontSize }    = other;
    const [ canComment,     setCanComment     ] = useState(false);
    const [ displayComment, setDisplayComment ] = useState(false);
    
    const questionStyle = [ MainStyle[`fs_${fontSize}`], 
                MainStyle.answer_text_body, 
                data.BOLD === "Y" ? MainStyle.fw_semibold: null];

    useEffect(() => {
        if (mainData.OBSERVATIONS === "Y") {
            setCanComment(true);
        }
    }, [mainData]);
    
    return(
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        {data.PREFIX != "" && (
                            <span className={questionStyle.join(" ")}>
                                {data.PREFIX + " "}
                            </span>                            
                        )}
                        <span className={questionStyle.join(" ")}>
                            {data[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                        {data.MANDATORY === "Y" && (
                            <span className={questionStyle.join(" ")}>
                                *
                            </span>                            
                        )}

                    </div>
                </div>
            </div>
            <div className={[MainStyle.row]}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.my_3}>
                        <div className={MainStyle.mx_3}>
                            {data.OPTIONS.length > 0 && (
                            data.OPTIONS.map((option, i) => {
                                    return(
                                        <QuestionType3Option
                                            data={option}
                                            mainData={mainData}
                                            setMainData={setMainData}
                                            sessionIndex={sessionIndex}
                                            questionIndex={questionIndex}
                                            optionIndex={i}
                                            lang={lang}
                                            fontSize={fontSize}
                                        />
                                    );
                            })
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {data.ANSWERS.length > 0 && (
                <CommentDisplay
                    data={data}
                    mainData={mainData}
                    setMainData={setMainData}
                    sessionIndex={sessionIndex}
                    questionIndex={questionIndex}
                    lang={lang}
                    fontSize={fontSize}
                    canComment={canComment}
                    setCanComment={setCanComment}
                    displayComment={displayComment}
                    setDisplayComment={setDisplayComment}
                />
            )}
        </>
    );
});

// #endregion

// #region Question Type 4
const QuestionType4Option = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            optionIndex,
            lang,
            fontSize        }  = other;

    const handleSelect = () => {
        setMainData((prevState) => {
            const session = prevState.SESSIONS[sessionIndex];
            const question = session.SESSION_QUESTIONS[questionIndex];
            const currentAnswers = question.ANSWERS || [];

            const exists = currentAnswers.some(
                (answer) => answer.OPTION_LIST_ITEM_ID === data.OPTION_LIST_ITEM_ID
            );

            let newAnswers;
            if (exists) {
                // Deselect (remove)
                newAnswers = currentAnswers.filter(
                    (answer) => answer.OPTION_LIST_ITEM_ID !== data.OPTION_LIST_ITEM_ID
                );
            } else {
                // Select (add)
                const newAnswer = {
                    ...data,
                    SESSION_ORDER: session.SESSION_ORDER,
                    QUESTION_ID: question.QUESTION_ID,
                    QUESTION_TYPE_ID: question.QUESTION_TYPE_ID,
                    QUESTION_POSITION: question.QUESTION_POSITION,
                };
                newAnswers = [...currentAnswers, newAnswer];
            }

            return {
                ...prevState,
                SESSIONS: prevState.SESSIONS.map((s, i) =>
                    i === sessionIndex
                        ? {
                            ...s,
                            SESSION_QUESTIONS: s.SESSION_QUESTIONS.map((q, j) =>
                                j === questionIndex
                                    ? { ...q, ANSWERS: newAnswers }
                                    : q
                            )
                        }
                        : s
                )
            };
        });
    };


    function IsChecked() {
        return mainData.SESSIONS[sessionIndex].SESSION_QUESTIONS[questionIndex].ANSWERS.some(
            (answer) => {
                if (answer.OPTION_LIST_ITEM_ID === data.OPTION_LIST_ITEM_ID) {
                    return true;
                }
                else {
                    return false;
                }
            }
        );
    }

    useEffect(() => {}, [lang, fontSize]);
    return (
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col_2}>
                    <input
                        type="checkbox"
                        name={"read"}
                        checked={IsChecked()}
                        onChange={()=> {handleSelect();}}
                        style={{ transform: "scale(1.2)" }}
                        disabled={false}
                        className={MainStyle.mx_3}
                    />
                </div>
                <div className={MainStyle.col_10}>
                    <span className={[MainStyle[`fs_${fontSize}`], MainStyle.answer_text_body].join(" ")}>
                        {data[`OPTION_LANG_${lang}_DESC`]}
                    </span>
                </div>
            </div>
        </>
    );
});

const QuestionType4 = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            lang,
            fontSize }    = other;
    const [ canComment,     setCanComment     ] = useState(false);
    const [ displayComment, setDisplayComment ] = useState(false);
    
    const questionStyle = [ MainStyle[`fs_${fontSize}`], 
                MainStyle.answer_text_body, 
                data.BOLD === "Y" ? MainStyle.fw_semibold: null];

    useEffect(() => {        
        if (mainData?.OBSERVATIONS === "Y") {
            setCanComment(true);
        }
    }, [mainData]);
    
    return(
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        {data.PREFIX != "" && (
                            <span className={questionStyle.join(" ")}>
                                {data.PREFIX + " "}
                            </span>                            
                        )}
                        <span className={questionStyle.join(" ")}>
                            {data[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                        {data.MANDATORY === "Y" && (
                            <span className={questionStyle.join(" ")}>
                                *
                            </span>                            
                        )}

                    </div>
                </div>
            </div>
            <div className={[MainStyle.row]}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.my_3}>
                        <div className={MainStyle.mx_3}>
                            {data.OPTIONS.length > 0 && (
                                data.OPTIONS.map((option, i) => {
                                        return(
                                            <QuestionType4Option
                                                data={option}
                                                mainData={mainData}
                                                setMainData={setMainData}
                                                sessionIndex={sessionIndex}
                                                questionIndex={questionIndex}
                                                optionIndex={i}
                                                lang={lang}
                                                fontSize={fontSize}
                                            />
                                        );
                                })
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {data.ANSWERS.length > 0 && (
                <CommentDisplay
                    data={data}
                    mainData={mainData}
                    setMainData={setMainData}
                    sessionIndex={sessionIndex}
                    questionIndex={questionIndex}
                    lang={lang}
                    fontSize={fontSize}
                    canComment={canComment}
                    setCanComment={setCanComment}
                    displayComment={displayComment}
                    setDisplayComment={setDisplayComment}
                />
            )}
        </>
    );
});


// #endregion

// #region Question Type 5
const QuestionType5Option = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            optionIndex,
            lang,
            fontSize        }  = other;

    const handleSelect = () => {
        setMainData((prevState) => {
            const sessions = [...prevState.SESSIONS];
            const session = sessions[sessionIndex];
            const question = session.SESSION_QUESTIONS[questionIndex];

            const newAnswer = {
                SESSION_ORDER: session.SESSION_ORDER,
                QUESTION_ID: question.QUESTION_ID,
                QUESTION_TYPE_ID: question.QUESTION_TYPE_ID,
                QUESTION_POSITION: question.QUESTION_POSITION,
                OPTION_LIST_ID: data.OPTION_LIST_ID,
                OPTION_LIST_ITEM_ID: data.OPTION_LIST_ITEM_ID,
                OPTION_LIST_ITEM_ORDER: data.OPTION_LIST_ITEM_ORDER,
            };

            sessions[sessionIndex].SESSION_QUESTIONS[questionIndex].ANSWERS = [newAnswer];

            return {
                ...prevState,
                SESSIONS: sessions
            };
        });
    };
    function IsChecked() {
        return mainData.SESSIONS[sessionIndex].SESSION_QUESTIONS[questionIndex].ANSWERS.some(
            (answer) => {
                if (answer.OPTION_LIST_ITEM_ID === data.OPTION_LIST_ITEM_ID) {
                    return true;
                }
                else {
                    return false;
                }
            }
        );
    }
    const ElementStyle = [  IsChecked() ?  MainStyle.npsForm_bg_selected : MainStyle.npsForm_bg, 
                            MainStyle.npsForm_Btn,
                            MainStyle.rounded_1, 
                            MainStyle.border, 
                            MainStyle.shadow_sm];
    useEffect(() => {}, [lang, fontSize]);
    return (
        <>
            <div style={{cursor: "pointer"}}
                 onClick={handleSelect} 
                 className={ElementStyle.join(" ")}
            >
                <span className={[MainStyle[`fs_${fontSize + 2}`], MainStyle.answer_text_body].join(" ")}>
                    {data[`OPTION_LANG_${lang}_DESC`]}
                </span>
            </div>
        </>
    );
});

const QuestionType5 = React.memo(({...other}) => {
    const { data,
            mainData,
            setMainData,
            sessionIndex,
            questionIndex,
            lang,
            fontSize }    = other;
    const [ canComment,     setCanComment     ] = useState(false);
    const [ displayComment, setDisplayComment ] = useState(false);
    
    const questionStyle = [ MainStyle[`fs_${fontSize}`], 
                MainStyle.answer_text_body, 
                data.BOLD === "Y" ? MainStyle.fw_semibold: null];

    useEffect(() => {
        if (mainData.OBSERVATIONS === "Y") {
            setCanComment(true);
        }
    }, [mainData]);
    
    return(
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        {data.PREFIX != "" && (
                            <span className={questionStyle.join(" ")}>
                                {data.PREFIX + " "}
                            </span>                            
                        )}
                        <span className={questionStyle.join(" ")}>
                            {data[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                        {data.MANDATORY === "Y" && (
                            <span className={questionStyle.join(" ")}>
                                *
                            </span>                            
                        )}

                    </div>
                </div>
            </div>
            <div className={[MainStyle.row]}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.my_3}>
                        <div className={MainStyle.mx_3}>
                            <div className={[MainStyle.d_flex, MainStyle.justify_content_around].join(" ")}>
                                {data.OPTIONS.length > 0 && (
                                    data.OPTIONS.map((option, i) => {
                                            return(
                                                <QuestionType5Option
                                                    data={option}
                                                    mainData={mainData}
                                                    setMainData={setMainData}
                                                    sessionIndex={sessionIndex}
                                                    questionIndex={questionIndex}
                                                    optionIndex={i}
                                                    lang={lang}
                                                    fontSize={fontSize}
                                                />
                                            );
                                    })
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {data.ANSWERS.length > 0 && (
                <CommentDisplay
                    data={data}
                    mainData={mainData}
                    setMainData={setMainData}
                    sessionIndex={sessionIndex}
                    questionIndex={questionIndex}
                    lang={lang}
                    fontSize={fontSize}
                    canComment={canComment}
                    setCanComment={setCanComment}
                    displayComment={displayComment}
                    setDisplayComment={setDisplayComment}
                />
            )}
        </>
    );
});

// #endregion

// #region Question Type 6
const QuestionType6 = React.memo(({...other}) => {
    const { data,
            lang,
            fontSize }    = other;
    
    const questionStyle = [ MainStyle[`fs_${fontSize}`], 
                MainStyle.answer_text_body, 
                data.BOLD === "Y" ? MainStyle.fw_semibold: null];
    
    return(
        <>
            <div className={MainStyle.row}>
                <div className={MainStyle.col}>
                    <div className={MainStyle.mx_3}>
                        {data.PREFIX != "" && (
                            <span className={questionStyle.join(" ")}>
                                {data.PREFIX + " "}
                            </span>                            
                        )}
                        <span className={questionStyle.join(" ")}>
                            {data[`QUESTION_LANG_${lang}_DESC`]}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
});

// #endregion



const SessionDivision = React.memo(({data}) => {
    return (
        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_3}/>
            <div className={MainStyle.col_lg}>
                <div className={MainStyle.mx_3}>
                    <div style={{backgroundColor: 'rgb(244 244 244)'}}
                         className={[MainStyle.mt_3,
                                     MainStyle.py_1,
                                     MainStyle.rounded].join(" ")}
                    />
                </div>
            </div>
            <div className={MainStyle.col_lg_3}/>
        </div>
    );
});

const SessionBlock = React.memo(({...other}) => {
    const { mainData,
            setMainData,
            data,
            sessionIndex,
            lang,
            fontSize                 } = other;
    useEffect(() => {

    }, [data]);
    return (
        <>
            {data.SESSION_LINES.length > 0 &&(
                <div className={MainStyle.my_3}>
                    <div className={MainStyle.row}>
                        <div className={MainStyle.col_lg_3}/>
                        <div className={MainStyle.col_lg}>
                            <div className={MainStyle.mx_3}>
                                <div className={[MainStyle.bg_card_answer, MainStyle.rounded_5, MainStyle.border].join(" ")}>
                                    <div className={[MainStyle.mx_3, MainStyle.py_3].join(" ")}>
                                        < div className={MainStyle.row}>
                                            < div className={MainStyle.col_9}>
                                                {data.SESSION_LINES.map((session_line, i) => {
                                                    return (
                                                        <SessionLine
                                                            data={session_line}
                                                            index={i}
                                                            lang={lang}
                                                            fontSize={fontSize}
                                                        />
                                                    );
                                                })}
                                            </div>
                                            < div className={MainStyle.col_3}>
                                                {data.SESSION_LINES.map((session_line, i) => {
                                                    return (
                                                        <TeacherLineAvatar
                                                            data={session_line}
                                                            lang={lang}
                                                            fontSize={fontSize}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={MainStyle.col_lg_3}/>
                    </div>
                </div>
            )}
            <div className={MainStyle.my_3}>
                <div className={MainStyle.row}>
                    <div className={MainStyle.col_lg_3}/>
                    <div className={MainStyle.col_lg}>
                        <div className={MainStyle.mx_3}>
                            {data.SESSION_QUESTIONS.map((question, i) => {
                                if (question.QUESTION_TYPE_ID === 1) {
                                    return (
                                        <QuestionType1
                                            data={question}
                                            mainData={mainData}
                                            setMainData={setMainData}
                                            sessionIndex={sessionIndex}
                                            questionIndex={i}
                                            lang={lang}
                                            fontSize={fontSize}
                                        />
                                    );
                                }
                                else if (question.QUESTION_TYPE_ID === 2) {
                                    return (
                                        <QuestionType2
                                            data={question}
                                            mainData={mainData}
                                            setMainData={setMainData}
                                            sessionIndex={sessionIndex}
                                            questionIndex={i}
                                            lang={lang}
                                            fontSize={fontSize}
                                        />
                                    );
                                }
                                else if (question.QUESTION_TYPE_ID === 3) {
                                    return (
                                        <QuestionType3
                                            data={question}
                                            mainData={mainData}
                                            setMainData={setMainData}
                                            sessionIndex={sessionIndex}
                                            questionIndex={i}
                                            lang={lang}
                                            fontSize={fontSize}
                                        />
                                    );
                                }
                                else if (question.QUESTION_TYPE_ID === 4) {
                                    return (
                                        <QuestionType4
                                            data={question}
                                            mainData={mainData}
                                            setMainData={setMainData}
                                            sessionIndex={sessionIndex}
                                            questionIndex={i}
                                            lang={lang}
                                            fontSize={fontSize}
                                        />
                                    );
                                }
                                else if (question.QUESTION_TYPE_ID === 5) {
                                    return (
                                        <QuestionType5
                                            data={question}
                                            mainData={mainData}
                                            setMainData={setMainData}
                                            sessionIndex={sessionIndex}
                                            questionIndex={i}
                                            lang={lang}
                                            fontSize={fontSize}
                                        />
                                    );
                                }
                                else if (question.QUESTION_TYPE_ID === 6) {
                                    return (
                                        <QuestionType6
                                            data={question}
                                            lang={lang}
                                            fontSize={fontSize}
                                        />
                                    );
                                }
                                else {
                                    return(null);
                                }
                            })}
                        </div>
                    </div>
                    <div className={MainStyle.col_lg_3}/>
                </div>
            </div>
            <SessionDivision data={mainData}/>
        </>
    );
});


export const OrderPreviewCodePage = ({return_path}) => {
    const [ data,       setData     ]  = useState(null); 
    const { orderCode               }  = useParams();
    const [ lang,       setLang     ]  = useState(null);             // Lang Control
    const [ langList,   setLangList ]  = useState(null);             // Lang List Control
    const [ fontSize,   setFontSize ]  = useState(6);
    const { showLoader, hideLoader  }  = useLoader();                // Control over the loader
    const { showInfoMessage         }  = useInfoMsgModal();          // Modal message control 
    const { showActionMessage       }  = useActionModal();           // Modal message + action control     
    const { showToastMessage        }  = useToastMessage();          // Toast message display
    const   controlRef                 = useRef(null);
    const   contentRef                 = useRef(null);
    const [ contentHeight, setContentHeight] = useState({});
    const [ controlHeight, setControlHeight] = useState({});
    const navigate                     = useNavigate();

    const {showBtnExit, hideBtnExit}  = useBtnExit();

    const ExitWrapper = ({children, onClick }) => {
        return(
            <div style={{   position: 'fixed', 
                            bottom: '0', 
                            //marginBottom: '1rem', 
                            cursor: 'pointer', 
                            zIndex: '10',
                            width: '100%'
                        }}
                  onClick={onClick}
            >
                {children}
            </div>
        );
    };
    const ExitContent = () => {
        return (
            <div className={[MainStyle.d_flex, MainStyle.align_items_center, MainStyle.justify_content_center, MainStyle.shadow, MainStyle.border, MainStyle.bg_card_item].join(" ")}>
                <svg viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg" 
                        className={[MainStyle.small_ico_person_door, MainStyle.m_2].join(" ")}
                >
                    <path d="M355.022,115.897c22.422,0,40.603-18.19,40.603-40.616c0-22.427-18.181-40.608-40.603-40.608 c-22.434,0-40.616,18.182-40.616,40.608C314.406,97.707,332.588,115.897,355.022,115.897z"/>
                    <path d="M509.402,232.445l-26.925-40.501c-6.543-9.57-15.22-17.486-25.33-23.155l-52.81-29.574 c-9.676-4.524-16.996-7.402-26.189-6.159l-25.268,3.436c-9.422,1.275-18.01,6.077-24.037,13.429l-48.096,51.183l-44.055,16.244 c-8.346,3.075-12.825,12.137-10.186,20.627l0.204,0.654c2.593,8.358,11.196,13.29,19.715,11.327l35.901-8.284 c8.952-2.07,17.458-5.758,25.072-10.894l24.97-16.783l8.816,67.033c0.647,4.916-0.343,9.913-2.822,14.214l-74.758,129.848 c-5.333,9.242-2.176,21.068,7.05,26.45l0.642,0.376c8.735,5.087,19.908,2.633,25.69-5.643l83.558-119.534l25.322,50.537 c1.873,3.738,4.351,7.132,7.336,10.044l56.164,54.92c7.091,6.928,18.305,7.23,25.747,0.712l0.9-0.786 c3.819-3.345,6.134-8.073,6.436-13.135c0.302-5.055-1.431-10.036-4.826-13.806l-47.421-52.818L424.44,269.16l-0.09,0.082 l-7.394-72.947l26.115,11.753l41.752,43.945c5.251,5.537,13.757,6.429,20.038,2.094l0.426-0.295 C512.256,248.999,514.096,239.495,509.402,232.445z"></path> 
                    <polygon points="129.123,101.06 43.287,42.435 262.74,42.435 262.74,8.934 0,8.934 0,444.44 43.287,444.44 129.123,503.066 129.123,486.315 129.123,444.44 233.8,444.44 233.8,410.94 129.123,410.94"/>
                </svg>
                <span className={[  MainStyle.fs_5,
                                    MainStyle.text_body  ].join(" ")}>
                    {GetLabel(null, 168)}
                </span>   
            </div>
        );
    };

    useEffect(() => {
        const fetchData = async (code) => {
            try {
                showLoader({logoElement: DefaultLoadingISELogo(), loadingMessage: GetLabel(null, 0)});
                let fetchedData = await getOrderPreviewByCode(code);
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            for (let i = 0; i < fetchedData.SESSIONS.length; i++) {
                                for (let k = 0; k < fetchedData.SESSIONS[i].SESSION_QUESTIONS.length;  k ++) {
                                    fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].OBSERVATION = "";
                                    if ((fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].QUESTION_TYPE_ID === 2) || (fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].QUESTION_TYPE_ID === 6)) {
                                        fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].ANSWERS = [];
                                        fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].ANSWERS.push({
                                                ...blank_answer_template,
                                                SESSION_ORDER:       fetchedData.SESSIONS[i].SESSION_ORDER,
                                                QUESTION_ID:         fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].QUESTION_ID,
                                                QUESTION_TYPE_ID:    fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].QUESTION_TYPE_ID,
                                                QUESTION_POSITION:   fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].QUESTION_POSITION,
                                                ANSWER_VALUE:        "",
                                        });
                                    }
                                    else {
                                        fetchedData.SESSIONS[i].SESSION_QUESTIONS[k].ANSWERS = [];
                                    }
                                }
                            }

                            if (fetchedData) {
                                const temp = [];
                                const userLang = (navigator.language || navigator.userLanguage).split('-')[0];

                                if (fetchedData.LANG_PT === "Y") {
                                    temp.push({ value: 'PT', label: 'Português' });
                                }
                                if (fetchedData.LANG_EN === "Y") {
                                    temp.push({ value: 'EN', label: 'English' });
                                }
                                if (fetchedData.LANG_ES === "Y") {
                                    temp.push({ value: 'ES', label: 'Español' });
                                }

                                let normalizedLang;
                                switch (userLang) {
                                    case 'pt':
                                        normalizedLang = 'PT';
                                        break;
                                    case 'en':
                                        normalizedLang = 'EN';
                                        break;
                                    case 'es':
                                        normalizedLang = 'ES';
                                        break;
                                    default:
                                        normalizedLang = temp[0]?.value;
                                }

                                const selectedLang = temp.find(lang => lang.value === normalizedLang)?.value || temp[0]?.value;

                                setLang(selectedLang);
                                setLangList(temp);
                            }

                            setData(fetchedData);
                            hideLoader();
                        }
                    }       
                    else {
                        hideLoader();
                        navigate("/404");
                    }
                }
            } 
            catch (error) {
                console.warn(`Error Trace: ${error}`);
                setData({});
                hideLoader();
                navigate("/404");
            }
        };
        fetchData(orderCode);
        showBtnExit({ 
            return_path: return_path, 
            fragmentPosition: ExitWrapper,
            fragmentContent: <ExitContent/>
        });
    }, [orderCode]);

    useLayoutEffect(() => {
        if ((data?.ORDER_CODE !== null) && (data?.ORDER_CODE !== undefined)) {
            const scrollY = window.scrollY;

            const contentElement = contentRef.current.getBoundingClientRect();
            const controlElement = controlRef.current.getBoundingClientRect();

            if (contentElement && controlElement) {
                setControlHeight({
                    height: controlElement.height,
                    top: controlElement.top + scrollY,
                    bottom: controlElement.bottom + scrollY
                });

                setContentHeight({
                    height: contentElement.height,
                    top: contentElement.top + scrollY,
                    bottom: contentElement.bottom + scrollY
                });
            }
        }
    }, [data, contentRef, controlRef]);
    
    function getEndPadding() {
        let elements = [], i = 0;
        while (i < 5) {
            elements.push(<DefaultPadding/>);
            ++i;
        }
        return elements;
    }

    return (
        <>
            {data?.ORDER_CODE && (
                <>            
                    <MinHeader
                        data={data}
                        lang={lang}
                        fontSize={fontSize} 
                        controlHeight={controlHeight}
                        contentHeight={contentHeight}
                    />
                    <InfoBlock 
                        data={data} 
                        langList={langList} 
                        lang={lang} 
                        setLang={setLang} 
                        fontSize={fontSize} 
                        setFontSize={setFontSize}
                    />
                    <div ref={controlRef}/>
                    <HeaderBlock 
                        data={data} 
                        lang={lang} 
                        fontSize={fontSize}
                        
                    />
                    <DefaultPadding/>
                    <div ref={contentRef}>
                    {
                        data?.SESSIONS.map((session, i) => {
                            return(
                                <SessionBlock
                                    mainData={data}
                                    setMainData={setData}
                                    data={session}
                                    sessionIndex={i}
                                    lang={lang}
                                    fontSize={fontSize}
                                />
                            );
                        })
                    }
                    </div>
                    {getEndPadding()}
                </>
            )}
        </>
    );
};